export const getVariantConcatenatedId = (
    itemId: string | undefined,
    color: string | undefined,
    size: string | undefined
): string | undefined => {
    if (!itemId || !color || !size) {
        return undefined;
    }
    const normalizedColor = color.replace(/ /g, '_').replace(/#/g, '');
    const normalizedSize = size.replace(/ /g, '_').replace(/\//g, '');

    return `${itemId}${normalizedColor}${normalizedSize}`;
};
